module.exports = __webpack_public_path__ + "img/jeweleries.9a027d75.svg";